import { render, staticRenderFns } from "./pickup.vue?vue&type=template&id=4416bf59&scoped=true"
import script from "./pickup.vue?vue&type=script&lang=js"
export * from "./pickup.vue?vue&type=script&lang=js"
import style0 from "./pickup.vue?vue&type=style&index=0&id=4416bf59&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4416bf59",
  null
  
)

export default component.exports